import { createTheme } from "@material-ui/core/styles";

export const wbMUITheme = createTheme({
  overrides: {
    MuiTooltip: {
      arrow: {
        color: "#000000",
      },
      tooltip: {
        fontFamily: "PT Sans Narrow",
        fontSize: "14px",
        color: "#FFFFFF",
        fill: "#FFFFFF",
        backgroundColor: "#000000",
        margin: "9px 0px !important",
      },
    },
    MuiChip: {
      root: {
        backgroundColor: "#EEEEEE",
        color: "#333",
      },
      label: {
        fontFamily: "PT Sans Narrow",
        fontSize: "16px",
        paddingLeft: "10px",
        paddingRight: "10px",
      },
      icon: {
        height: "24px",
        width: "24px",
      },
      deleteIcon: {
        color: "#757575",
        height: "16.8px",
        width: "16.8px",
        marginRight: "8px",
      },
      deletable: {
        "&:focus": {
          backgroundColor: "#B1B1B1",
        },
        "&:hover": {
          backgroundColor: "#C1C1C1;",
        },
      },
    },
  },
});
